import DefaultModal from "components/Common/Modal/DefaultModal";
import ModalButton from "components/Common/Modal/ModalButton";
import React from "react";
import { useNavigate } from "react-router-dom";

const PendingModal = ({ modalClose }: { modalClose: () => void }) => {
  const navigate = useNavigate();

  return (
    <DefaultModal
      title="현재 가입승인 대기 상태입니다"
      content={`관리자에 의한 가입 승인이 완료된 후,\n로그인이 가능합니다.\n승인처리 지연 시 시스템 관리자에게 문의바랍니다.`}
      handlModalClose={modalClose}
      state="error"
      button={
        <ModalButton
          confirmButtonText="홈으로 돌아가기"
          handleConfirm={() => {
            navigate("/data-room");
            modalClose();
          }}
        />
      }
    />
  );
};

export default PendingModal;
